import React from "react";
import Title from "designs/v1/components/Title";
import Button from "designs/v1/components/Button";

export default function BankModificationESignature({ setStageScreen }) {
  return (
    <React.Fragment>
      <Title title="Thank You!" />
      <div className="col-md-12 mt-3">
        <h3>
          eSign email is sent to your Inbox, please complete esign. Once done
          successfully, you will be notified by our team.
        </h3>
        <div className="mt-4">
          <Button
            type="button"
            title="Back To Home"
            handleClick={() => setStageScreen("ModificationType")}
          />
        </div>
      </div>
    </React.Fragment>
  );
}
